import { Box, Button, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

export const FadedText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const NumberText = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0, 0.5),
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.body2.fontWeight,
  height: '20px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const GrayBorderStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2, 1),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
}));

export const DarkenedBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: 0,
}));

export const ToggleButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.divider,
  borderRadius: theme.spacing(2.5),
  height: '40px',
  padding: `0 ${theme.spacing(0.5)}`,
}));

export const ToggleButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.text.secondary,
  border: 'none',
  width: '50%',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
